"use client";

export default function SidebarFallback() {
	return null;
}
